// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * A collection's file strip and its Cache files row. Colours, type and
 * geometry come from ../../../styles/curioTokens.css.
 */

.h4EqzTpKalgas_HsgeDk {
  display: flex;
  gap: 6px;
  padding: 12px 20px;
  overflow-x: auto;
  border-bottom: 1px solid var(--curio-border);
  background: var(--curio-page-bg);
}

.RHMeSTkDWvGILMxKWGk5 {
  flex: 0 0 auto;
  display: block;
  width: 96px;
  height: 72px;
  border-radius: var(--curio-radius-md);
  object-fit: cover;
  background: var(--curio-surface-muted);
}

.uCutjS9JaCjdF9S2bKW5 {
  opacity: 0.5;
}

._I1B8U7mH_uswjKTmuSg {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
}

/* Dark filled = an action, matching every other catalog surface. */
.c3lfD4ttOsgexQhTwIvG {
  flex-shrink: 0;
  height: 30px;
  border: 0;
  border-radius: var(--curio-radius-lg);
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
  padding: 0 14px;
  font-family: inherit;
  font-size: var(--curio-font-size-sm);
  font-weight: 600;
  cursor: pointer;
}

.c3lfD4ttOsgexQhTwIvG:hover:not(:disabled) {
  background: var(--curio-top-bar-bg-hover);
}

.c3lfD4ttOsgexQhTwIvG:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.l3O0Fnm31KMNzykR02_f {
  font-size: var(--curio-font-size-xs);
  color: var(--curio-text-meta);
}
`, "",{"version":3,"sources":["webpack://./src/components/datasets/catalog/DatasetCollectionPanel.module.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,qCAAqC;EACrC,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B","sourcesContent":["/*\n * A collection's file strip and its Cache files row. Colours, type and\n * geometry come from ../../../styles/curioTokens.css.\n */\n\n.strip {\n  display: flex;\n  gap: 6px;\n  padding: 12px 20px;\n  overflow-x: auto;\n  border-bottom: 1px solid var(--curio-border);\n  background: var(--curio-page-bg);\n}\n\n.thumb {\n  flex: 0 0 auto;\n  display: block;\n  width: 96px;\n  height: 72px;\n  border-radius: var(--curio-radius-md);\n  object-fit: cover;\n  background: var(--curio-surface-muted);\n}\n\n.thumbFailed {\n  opacity: 0.5;\n}\n\n.cacheRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n/* Dark filled = an action, matching every other catalog surface. */\n.cacheButton {\n  flex-shrink: 0;\n  height: 30px;\n  border: 0;\n  border-radius: var(--curio-radius-lg);\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n  padding: 0 14px;\n  font-family: inherit;\n  font-size: var(--curio-font-size-sm);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.cacheButton:hover:not(:disabled) {\n  background: var(--curio-top-bar-bg-hover);\n}\n\n.cacheButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.cacheNote {\n  font-size: var(--curio-font-size-xs);\n  color: var(--curio-text-meta);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"strip": `h4EqzTpKalgas_HsgeDk`,
	"thumb": `RHMeSTkDWvGILMxKWGk5`,
	"thumbFailed": `uCutjS9JaCjdF9S2bKW5`,
	"cacheRow": `_I1B8U7mH_uswjKTmuSg`,
	"cacheButton": `c3lfD4ttOsgexQhTwIvG`,
	"cacheNote": `l3O0Fnm31KMNzykR02_f`
};
export default ___CSS_LOADER_EXPORT___;
